import type { ShopAsset } from '@/hooks/useAssets';
import type { AssetDowntimeEvent } from '@/hooks/useAssetDowntime';

/**
 * Determines whether an asset is currently available for scheduling/use.
 *
 * An asset is available iff:
 *  - status === 'active', AND
 *  - it has no open downtime event.
 *
 * Visual-only today; intended to be the single source of truth for future
 * scheduler integration.
 */
export function isAssetAvailable(
  asset: Pick<ShopAsset, 'status'> | null | undefined,
  activeDowntime?: AssetDowntimeEvent | null,
): boolean {
  if (!asset) return false;
  if (asset.status !== 'active') return false;
  if (activeDowntime && activeDowntime.ended_at === null) return false;
  return true;
}

/**
 * Lightweight check that only inspects asset.status. Use when downtime data
 * is not loaded (e.g. list rendering where we already filter by status).
 */
export function isAssetStatusAvailable(asset: Pick<ShopAsset, 'status'> | null | undefined): boolean {
  return asset?.status === 'active';
}
